import { defineRouter } from '@quasar/app-vite/wrappers'
import {
   createMemoryHistory,
   createRouter,
   createWebHashHistory,
   createWebHistory,
} from 'vue-router';
import { useAuthStore } from '../stores/auth';

import routes from './routes';

type PublicSeoHead = {
   title: string;
   description: string;
   canonicalPath: string;
};

const publicSeoHeadByPath: Record<string, PublicSeoHead> = {
   '/': {
      title: 'گپ جی پی تی | هوش مصنوعی فارسی',
      description: 'گپ جی پی تی، پلتفرم هوش مصنوعی فارسی برای کاربران ایرانی. هوش مصنوعی رایگان، چت با هوش مصنوعی فارسی، هوش مصنوعی ساخت عکس، گفتگوی صوتی، ترجمه مقاله و دستیار هوشمند. دسترسی به پیشرفته‌ترین مدل‌های هوش مصنوعی.',
      canonicalPath: '/',
   },
   '/pricing': {
      title: 'قیمت و خرید اشتراک گپ جی پی تی | ChatGPT Plus فارسی',
      description: 'پلن‌های گپ جی پی تی برای چت با مدل‌های هوش مصنوعی، ChatGPT Plus، ساخت تصویر، تحلیل فایل و استفاده حرفه‌ای از هوش مصنوعی فارسی.',
      canonicalPath: '/pricing',
   },
   '/download': {
      title: 'دانلود چت جی پی تی برای اندروید و آیفون | گپ جی پی تی',
      description: 'دانلود و نصب گپ جی پی تی برای اندروید و آیفون؛ چت جی پی تی فارسی، دسترسی بدون تحریم شکن، نسخه وب اپلیکیشن و شروع رایگان چت.',
      canonicalPath: '/download',
   },
   '/gemini': {
      title: 'جمینی فارسی | چت با هوش مصنوعی Gemini گوگل',
      description: 'دسترسی فارسی به Gemini و مدل‌های گوگل برای چت، ترجمه، کدنویسی، تحلیل فایل و استفاده از هوش مصنوعی جمینی در گپ جی پی تی.',
      canonicalPath: '/gemini',
   },
   '/translate': {
      title: 'ترجمه با هوش مصنوعی | مترجم فارسی گپ جی پی تی',
      description: 'ترجمه سریع و دقیق متن با هوش مصنوعی در گپ جی پی تی؛ مناسب ترجمه فارسی، انگلیسی و زبان‌های دیگر با لحن‌های مختلف.',
      canonicalPath: '/translate',
   },
   '/enterprise': {
      title: 'بسته سازمانی هوش مصنوعی | ChatGPT سازمانی با فاکتور رسمی',
      description: 'بسته سازمانی هوش مصنوعی گپ جی پی تی برای شرکت‌ها؛ خرید ChatGPT سازمانی با فاکتور رسمی، مدیریت کاربران، کنترل مصرف و پشتیبانی فارسی.',
      canonicalPath: '/enterprise',
   },
   '/about-us': {
      title: 'درباره گپ جی پی تی | پلتفرم هوش مصنوعی فارسی',
      description: 'گپ جی پی تی پلتفرم فارسی هوش مصنوعی برای دسترسی ساده به ChatGPT، Claude، Gemini، ساخت تصویر، ترجمه و ابزارهای هوشمند است.',
      canonicalPath: '/about-us',
   },
   '/ai-api': {
      title: 'API هوش مصنوعی گپ جی پی تی | مدل‌های ChatGPT، Claude و Gemini',
      description: 'API هوش مصنوعی گپ جی پی تی برای توسعه‌دهندگان؛ دسترسی به مدل‌های متنی، تصویری و صوتی با پرداخت ریالی و مستندات فارسی.',
      canonicalPath: '/ai-api',
   },
   '/contact-sales': {
      title: 'تماس با فروش گپ جی پی تی | راهکار سازمانی و API',
      description: 'برای خرید سازمانی، راهکار تیمی یا استفاده از API هوش مصنوعی گپ جی پی تی با تیم فروش و پشتیبانی فارسی در ارتباط باشید.',
      canonicalPath: '/contact-sales',
   },
   '/platform-v2/docs/quickstart': {
      title: 'API هوش مصنوعی فارسی | شروع سریع گپ جی پی تی',
      description: 'راهنمای سریع API هوش مصنوعی فارسی گپ جی پی تی؛ ساخت کلید API، اتصال Cursor و n8n، تنظیم Base URL و شروع استفاده از مدل‌های GPT، Claude و Gemini.',
      canonicalPath: '/platform-v2/docs/quickstart',
   },
   '/platform-v2/pricing': {
      title: 'قیمت API هوش مصنوعی | GPT، Claude و Gemini در گپ جی پی تی',
      description: 'مقایسه قیمت API مدل‌های GPT، Claude و Gemini در گپ جی پی تی؛ بررسی هزینه مصرف، مدل‌های متنی و تصویری و انتخاب مدل مناسب محصول.',
      canonicalPath: '/platform-v2/pricing',
   },
   '/platform-v2/models': {
      title: 'مدل‌های API گپ جی پی تی | مستندات مدل‌های هوش مصنوعی',
      description: 'فهرست مدل‌های API گپ جی پی تی برای توسعه‌دهندگان، همراه با معرفی مدل‌ها، کاربردها و مسیر اتصال از طریق مستندات فارسی.',
      canonicalPath: '/platform-v2/models',
   },
};

function normalizePublicSeoPath(path: string): string {
   if (!path || path === '/') return '/';
   return path.replace(/\/+$/, '');
}

function canonicalUrl(path: string): string {
   return path === '/' ? 'https://gapgpt.app/' : `https://gapgpt.app${path}`;
}

function setSingleMeta(attributeName: 'name' | 'property', key: string, content: string): void {
   const selector = `meta[${attributeName}="${key}"]`;
   const existing = Array.from(document.querySelectorAll<HTMLMetaElement>(selector));
   const meta = existing.shift() || document.createElement('meta');
   meta.setAttribute(attributeName, key);
   meta.setAttribute('content', content);
   for (const duplicate of existing) duplicate.remove();
   if (!meta.parentElement) document.head.appendChild(meta);
}

function setSingleCanonical(href: string): void {
   const existing = Array.from(document.querySelectorAll<HTMLLinkElement>('link[rel="canonical"]'));
   const canonical = existing.shift() || document.createElement('link');
   canonical.setAttribute('rel', 'canonical');
   canonical.setAttribute('href', href);
   for (const duplicate of existing) duplicate.remove();
   if (!canonical.parentElement) document.head.appendChild(canonical);
}

function applyPublicSeoHead(config: PublicSeoHead): void {
   const url = canonicalUrl(config.canonicalPath);
   document.title = config.title;
   setSingleMeta('name', 'description', config.description);
   setSingleMeta(
      'name',
      'robots',
      'index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1',
   );
   setSingleMeta('property', 'og:title', config.title);
   setSingleMeta('property', 'og:description', config.description);
   setSingleMeta('property', 'og:url', url);
   setSingleMeta('property', 'og:type', 'website');
   setSingleMeta('property', 'og:locale', 'fa_IR');
   setSingleMeta('name', 'twitter:title', config.title);
   setSingleMeta('name', 'twitter:description', config.description);
   setSingleMeta('name', 'twitter:card', 'summary');
   setSingleCanonical(url);
}

function schedulePublicSeoHeadSync(path: string): void {
   if (typeof window === 'undefined' || typeof document === 'undefined') return;
   const config = publicSeoHeadByPath[normalizePublicSeoPath(path)];
   if (!config) return;

   window.setTimeout(() => applyPublicSeoHead(config), 0);
   window.setTimeout(() => applyPublicSeoHead(config), 250);
}

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
   const createHistory = process.env.SERVER
      ? createMemoryHistory
      : process.env.VUE_ROUTER_MODE === 'history'
         ? createWebHistory
         : createWebHashHistory;

   const Router = createRouter({
      scrollBehavior: () => ({ left: 0, top: 0 }),
      routes,

      // Leave this as is and make changes in quasar.conf.js instead!
      // quasar.conf.js -> build -> vueRouterMode
      // quasar.conf.js -> build -> publicPath
      history: createHistory(process.env.VUE_ROUTER_BASE),
   });

   Router.beforeEach((to, from, next) => {
      const authStore = useAuthStore();
      const isStatusHost = typeof window !== 'undefined' && window.location.hostname === 'status.gapgpt.app';

      if (isStatusHost && to.path !== '/status') {
         next({ path: '/status', query: to.query, hash: to.hash });
         return;
      }
      
      if (to.meta.requiresAuth && !authStore.isAuthenticated()) {
         // Parse the redirectTo path and query parameters
         const redirectTo = (to.meta.redirectTo as string) || '/login';
         const [path, queryString] = redirectTo.split('?');
         const redirectQuery: Record<string, string> = {};
         
         // Parse query parameters from redirectTo if they exist
         if (queryString) {
            queryString.split('&').forEach(param => {
               const [key, value] = param.split('=');
               redirectQuery[key] = value;
            });
         }
         
         // Add the redirect path to query parameters
         redirectQuery.redirect = to.fullPath;
         
         next({ 
            path,
            query: redirectQuery
         });
      } else {
         next();
      }
   });

   Router.afterEach((to) => {
      schedulePublicSeoHeadSync(to.path);
   });

   return Router;
});
